module.exports = __webpack_public_path__ + "img/9791156330523.77f781e9.jpg";